import { Divider } from "@heroui/react";
import type { FC } from "react";

import ContainerComponent from "@/components/global/ContainerComponent/ContainerComponent";
import SkeletonCheckbox from "@/components/global/ControllerInput/BaseUI/Checkbox/SkeletonCheckbox";
import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";
import SkeletonTabComponent from "@/components/global/TabComponent/SkeletonTabComponent";
import { cn } from "@/utils/common/styleHelper/utils";

const SkeletonCarSearchPanelComponent: FC = () => {
  const dynamicWidth = [
    "md:w-[480px]",
    "md:w-[480px]",
    "hidden md:block md:w-40",
  ];

  return (
    <ContainerComponent className="size-full gap-4 rounded-2xl bg-white p-4 text-black shadow-sPlus md:px-6 md:pb-6 md:shadow-search xl:px-6">
      <SkeletonTabComponent
        length={2}
        classNames={{ container: "w-full md:w-[120px]" }}
      />
      <Skeleton className="h-16 w-full" />
      <div className="flex w-full flex-col gap-4 md:flex-row">
        {dynamicWidth.map((width, index) => (
          <Skeleton key={index} className={cn("h-16 w-full", width)} />
        ))}
      </div>

      <div className="flex size-full flex-col-reverse gap-4 md:flex-row">
        <SkeletonCheckbox className="flex w-2/5 items-center md:w-[10%]" />
        <Divider
          className="hidden h-auto bg-lightGrey md:block"
          orientation="vertical"
        />
        <div className="flex size-full items-center justify-between md:w-1/5 md:justify-start md:gap-2">
          <div className="flex h-6 w-2/5 items-center md:w-full">
            <Skeleton className="h-3.5 w-full" />
          </div>
          <Skeleton className="h-6 w-2/5 md:w-full" />
        </div>
        <Divider
          className="hidden h-auto bg-lightGrey md:block"
          orientation="vertical"
        />
        <div className="flex size-full items-center justify-between md:w-1/5 md:justify-start md:gap-2">
          <div className="flex h-6 w-2/5 items-center md:w-full">
            <Skeleton className="h-3.5 w-full" />
          </div>
          <Skeleton className="h-6 w-2/5 md:w-full" />
        </div>
      </div>
      <Skeleton className="h-12 w-full md:hidden" />
    </ContainerComponent>
  );
};

export default SkeletonCarSearchPanelComponent;
